<template>
	<div>
		<section id="trivia_welcome" class="section pb-0 section-components" v-if="!autodromo">
			<div class="container-fluid mb-5 text-center">
				<!-- Inputs -->
				<h1 class="mb-1" style="color: #000">
					<b>Trivia Mobil</b><sup>™</sup><b> F1</b>
				</h1>
				<template v-if="!fase2 && !consulta">
					<div class="mt-5">
						<p style="color: #000">
							Un reto para verdaderos aficionados. <br />
							¿Qué tanto conoces de la historia de la F1 en México?
						</p>
					</div>
					<div class="mb-3">
						<p style="color: #000">
							Te retamos a responder correctamente las siguientes 3 preguntas.
							<br />
							¡Tienes 45 segs para lograrlo aprovecha tu oportunidad!
						</p>
					</div>
					<h1 style="color: #000" class="mt-5"><b>¿List@?</b></h1>
					<div class="mt-3">
						<h4 style="color: #000">
							<b
								>¡Espera! Gana una oportunidad más para participar:
								<br v-if="!isMobile" />
								¿Eres usuario RETO MOBIL</b
							><sup>™</sup><b>?</b>
						</h4>
					</div>
					<div class="mt-5">
						<div v-if="!repeat">
							<div class="row justify-content-center">
								<div class="col-md-3">
									<input
										type="text"
										class="form-control"
										placeholder="Ingresa tu usuario de RETO MOBIL™ aquí"
										v-model="user_reto"
									/>
									<small class="help-block" v-if="errorUser">{{
										mensajeRepet
									}}</small>
									<button
										style="background: #007bff"
										type="button"
										class="btn btn-primary p-1 mt-4 mb-4 pl-5 pr-5"
										id="enviar"
										@click="validaUser()"
									>
										Validar usuario
										<b-spinner small v-if="loader"></b-spinner>
									</button>
								</div>
							</div>
						</div>
						<div v-else>
							<h4 style="color: #000">
								Bienvenid@ Usuario Reto Mobil:
								<b style="color: #00579e">{{ user_reto }}</b>
							</h4>
						</div>
						<h6 class="mt-2" style="color: #000" v-if="!repeat">
							si aún no cuentas con usuario visita:
							<b
								><a
									style="color: #000"
									href="https://www.retomobil.com"
									target="_target"
									>www.retomobil.com</a
								></b
							>
							y regístrate
						</h6>
					</div>
					<h4 class="mt-5" style="color: #000">
						<strong>¡Ahora sí! clic sobre el reloj para iniciar:</strong>
					</h4>
				</template>
			</div>
			<div class="container-fluid">
				<div class="row justify-content-center" v-if="!fase2 && !consulta">
					<div class="col-md-4">
						<div class="text-center">
							<h2
								style="cursor: pointer"
								@click="_setInterval()"
								id="countdown2"
							>
								Tiempo: {{ countdown }}
							</h2>
						</div>
						<br />
						<div id="preguntas_box" v-if="mostrarPregunta">
							<div v-for="pre in preguntas" :key="pre.id" class="container">
								<b style="font-size: small; color: #000">{{ pre.question }}</b>
								<div v-for="res in respuestas" :key="res.id">
									<div v-if="res.question_id == pre.id">
										<b-form-radio
											v-model="cuestionario[pre.id]"
											:value="res.id"
											size="lg"
											><p style="font-size: small; color: #000">
												{{ res.answer }}
											</p></b-form-radio
										>
									</div>
								</div>
							</div>

							<div class="text-center mt-5">
								<button
									style="background: #007bff"
									type="button"
									class="btn btn-primary p-1 mt-4 mb-4 pl-5 pr-5"
									id="enviar"
									@click="guardarPregunta()"
								>
									Enviar
									<b-spinner small v-if="loader"></b-spinner>
								</button>
							</div>
						</div>
						<hr style="border-top: 2px solid #f5f5f5 !important" />
					</div>
				</div>

				<div class="row justify-content-center">
					<div class="col-md-6" v-if="consulta">
						<center>
							<div id="fase1_pass" class="shadow-lg p-3 mt-5 bg-white text-center" v-if="fase2">
								<img
									:src="require('@/assets/img/bandera.png')"
									alt=""
									id="checkImage"
								/>
								<h3 style="color: #007bff"><strong>¡Felicidades!</strong></h3>
								<h5 style="color: #000">
									<strong>Haz pasado la FASE 1.</strong>
								</h5>
								<h6 class="mt-4" style="color: #000">
									<strong
										>¡Ya casi eres dueño de uno de los 10 <br />
										Boletos dobles para la Gran Carrera!</strong
									>
								</h6>
								<br />
							</div>
							<button
								style="background: #007bff"
								class="btn btn-primary mt-5"
								v-if="fase2"
								@click="autodromo = 1"
							>
								Continuar FASE 2
							</button>
							<div
								id="fase1_fail"
								class="shadow-lg p-3 mb-5 bg-white text-center"
								v-if="!fase2 && consulta"
							>
								<img
									:src="require('@/assets/img/error.png')"
									alt=""
									id="checkImage2"
								/>
								<h5 class="text-danger mt-4"><strong>¡Lo sentimos!</strong></h5>
								<h6 class="text-danger mt-2">
									<strong
										>Alguna de tus respuestas resultó incorrecta. <br />
										¡Gracias por participar!</strong
									>
								</h6>
								<h6 class="mt-5" style="color: #000; font-size: small">
									Sigue cargando con nosotros <br />
									y <strong>GANA más oportunidades</strong> para llevarte uno de
									los <br />
									10 boletos dobles para la gran carrera de la F1 en Cd. De
									México.
								</h6>

								<button
									style="background: #007bff"
									class="btn btn-primary mt-4"
									v-if="!fase2 && consulta"
									@click="regresaTodo()"
								>
									Inicio
								</button>
							</div>

							<div
								class="mt-3"
								v-if="
									!fase2 &&
									consulta &&
									!repeat &&
									mensajeRepet != 'ya no cuentas con más oportunidades'
								"
							>
								<h4 style="color: #000">
									<b
										>¡Espera! Gana una oportunidad más para participar:
										<br v-if="!isMobile" />
										¿Eres usuario RETO MOBIL</b
									><sup>™</sup><b>?</b>
								</h4>
							</div>
							<div
								class="mt-5"
								v-if="
									!fase2 &&
									consulta &&
									mensajeRepet != 'ya no cuentas con más oportunidades'
								"
							>
								<div v-if="!repeat">
									<div class="row justify-content-center">
										<div class="col-md-5">
											<input
												type="text"
												class="form-control"
												placeholder="Ingresa tu usuario de RETO MOBIL™ aquí"
												v-model="user_reto"
											/>
											<small class="help-block" v-if="errorUser">{{
												mensajeRepet
											}}</small>
											<button
												style="background: #007bff"
												type="button"
												class="btn btn-primary p-1 mt-4 mb-4 pl-5 pr-5"
												id="enviar"
												@click="validaUser()"
											>
												Validar usuario
												<b-spinner small v-if="loader"></b-spinner>
											</button>
										</div>
									</div>
								</div>
								<div v-else>
									<h4 style="color: #000">
										Usuario Reto Mobil:
										<b style="color: #00579e">{{ user_reto }}</b>
									</h4>
									<h5 style="color: #000">
										{{ mensajeRepet }}
									</h5>
									<button
										v-if="repeat"
										style="background: #007bff"
										type="button"
										class="btn btn-primary p-1 mt-4 mb-4 pl-5 pr-5"
										id="enviar"
										@click="repetTrivia()"
									>
										Repetir Trivia
										<b-spinner small v-if="loader"></b-spinner>
									</button>
								</div>
								<h6 class="mt-2" style="color: #000">
									si aún no cuentas con usuario visita:
									<b
										><a
											style="color: #000"
											href="https://www.retomobil.com"
											target="_target"
											>www.retomobil.com</a
										></b
									>
									y regístrate
								</h6>
							</div>
						</center>
						<br /><br />
						<hr style="border-top: 2px solid #f5f5f5 !important" />
						<br />
					</div>
				</div>
			</div>
		</section>
		<Autodromo v-else :customer="customer"></Autodromo>
	</div>
</template>
<script>
import axios from "axios";
import CountDown from "./CountDown";
import Autodromo from "./Autodromo";
import * as moment from "moment";
export default {
	components: {
		CountDown,
		Autodromo,
	},
	props: ["customer"],
	data() {
		return {
			preguntas: [],
			respuestas: [],
			tiempo: 0,
			cuestionario: [],
			fase2: 0,
			consulta: 0,
			loader: false,
			autodromo: 0,
			isMobile: this.$mobile(),
			// contador
			countdown: moment.utc(32).format("HH:mm:ss"),
			expires_in: 45,
			interval: null,
			Clickinterval: false,
			mostrarPregunta: 0,
			user_reto: "",
			errorUser: 0,
			repeat: 0,
			mensajeRepet: "",
			repetir: 0,
			timeoff: 0,
			ocultar: 0,
			contestado: false,
		};
	},
	mounted() {
		console.log('mounted confirmacion');
		this.getPreguntas();
		setTimeout(() => {
			this.$scrollTo('#trivia_welcome', 800, {
				offset: 0,
			});
		}, 500);
	},
	destroyed() {
		clearInterval(this.interval);
	},
	methods: {
		getPreguntas() {
			axios
				.get(this.$root.$urlApi+"api_questions")
				.then(({ data }) => {
					this.preguntas = data;
					this.getRespuestas();
				});
		},
		getRespuestas() {
			axios
				.get(this.$root.$urlApi+"api_answer")
				.then(({ data }) => {
					this.respuestas = data;
				});
		},
		guardarPregunta() {
			this.loader = true;
			axios
				.post(this.$root.$urlApi+"api_save_questionForm", {
					customer_id: this.customer,
					user_name: this.user_reto,
					repeat: this.repetir,
					answers: this.cuestionario,
					tiempo: this.tiempo,
				})
				.then((response) => {
					if (this.repetir) {
						this.validaUser();
					}
					this.fase2 = response.data.request;
					this.consulta = 1;
					this.timeoff = 1;
					this.loader = false;
					this.contestado = true;
					let anchor = (this.fase2) ? '#fase1_pass' : '#fase1_fail';
					setTimeout(() => {
						this.$scrollTo(anchor, 800, {
							offset: -100,
						});
					}, 500);
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		_setInterval() {
			this.mostrarPregunta = 1;
			this.expires_in = 45;
			this.tiempo = 0;
			setTimeout(() => {
				this.$scrollTo('#preguntas_box', 800, {
					offset: -50,
				});
			}, 500);
			if (this.Clickinterval == false) {
				this.interval = setInterval(() => {
					this.tiempo++;
					if (this.expires_in === 0) {
						clearInterval(this.interval);
					} else {
						this.expires_in -= 1;
						if (this.expires_in > 0) {
							this.countdown = moment
								.utc(this.expires_in * 1000)
								.subtract(1, "seconds")
								.format("HH:mm:ss");
						} else {
							if (!this.fase2) {
								this.consulta = 1;
								this.mostrarPregunta = 0;
								if (!this.timeoff && this.user_reto) {
									this.descontarOportunidad();
								}
							}
						}
					}
				}, 1000);
				this.Clickinterval = true;
			}
		},
		descontarOportunidad() {
			this.contestado = true;
			axios
				.get(
					this.$root.$urlApi+"api_validate_user_challenge_time/" +
						this.user_reto
				)
				.then(({ data }) => {
					console.log(data);
					this.validaUser();
				});
		},
		validaUser() {
			this.loader = true;
			this.ocultar = 0;
			if (!this.user_reto) {
				this.errorUser = 1;
				this.mensajeRepet = "Ingrese usuario";
				this.loader = false;
			} else {
				let url = !this.contestado
					? this.$root.$urlApi+"api_validate_user_challenge/"
					: this.$root.$urlApi+"api_validate_user_challenge2/";
				axios
					.get(url + this.user_reto)
					.then(({ data }) => {
						this.errorUser = 0;
						this.repeat = data.request;
						this.mensajeRepet = data.menssage;
						this.loader = false;
						
					})
					.catch((err) => {
						if (err.response.status === 404) {
							if (!err.response.data.request) {
								this.errorUser = 1;
								this.repeat = err.response.data.request;
								this.mensajeRepet = err.response.data.menssage;
								this.loader = false;
								this.ocultar = 1;
							}
						}
					});
			}
		},
		repetTrivia() {
			this.getPreguntas();
			clearInterval(this.interval);
			this.fase2 = 0;
			this.consulta = 0;
			this.countdown = moment.utc(32).format("HH:mm:ss");
			this.expires_in = 0;
			this.interval = null;
			this.Clickinterval = false;
			this.mostrarPregunta = 0;
			this.cuestionario = [];
			this.repetir = 1;
			this.timeoff = 0;
		},
		regresaTodo() {
			location.reload();
		},
	},
};
</script>
<style>
.rounded {
	width: 50% !important;
	border-radius: 16px !important;
}
#checkImage {
	width: 60% !important;
	margin-top: -20%;
}
#checkImage2 {
	width: 11% !important;
}
#checkImage3 {
	width: 100% !important;
}
#countdown {
	font-size: 30px;
	color: #00579e;
}
#countdown2 {
	font-size: 30px;
	background-color: #304596;
	color: #fff;
	display: inline-block;
	padding: 20px 50px;
	font-weight: 500;
}
</style>
